// Extracts the Vimeo video ID from various URL formats
// Supports:
// - https://vimeo.com/VIDEO_ID
// - https://vimeo.com/channels/*/VIDEO_ID
// - https://player.vimeo.com/video/VIDEO_ID
export const extractVimeoVideoId = (url) => {
  if (!url) return null;

  // Pattern to match Vimeo video IDs (numeric)
  const patterns = [
    // vimeo.com/VIDEO_ID
    /(?:vimeo\.com\/)(\d+)/,
    // player.vimeo.com/video/VIDEO_ID
    /(?:player\.vimeo\.com\/video\/)(\d+)/,
  ];

  for (const pattern of patterns) {
    const match = url.match(pattern);
    if (match && match[1]) {
      return match[1];
    }
  }

  return null;
};

// Converts any Vimeo URL to a proper embed URL
// Returns: https://player.vimeo.com/video/VIDEO_ID with parameters for cleaner UI
export const convertToVimeoEmbedUrl = (url) => {
  const videoId = extractVimeoVideoId(url);
  if (!videoId) {
    return url;
  }

  return `https://player.vimeo.com/video/${videoId}?byline=0&portrait=0&title=0`;
};

// Validates if a URL is a valid Vimeo video URL
export const isValidVimeoUrl = (url) => {
  return extractVimeoVideoId(url) !== null;
};
